import React from 'react';
import { PenIcon } from 'lucide-react';
export const PaymentMethod = () => {
  return <div className="flex items-center" data-id="element-93"></div>;
};